const CORE_COLORS = {
    neutrals: {
        white: '#ffffff',
        '050': '#FAFAFA',
        '100': '#F2F2F2',
        '200': '#E6E6E6',
        '300': '#CCCCCC',
        '400': '#B3B3B3',
        '500': '#999999',
        '600': '#808080',
        '700': '#666666',
        '800': '#4D4D4D',
        '900': '#333333',
        '950': '#232323',
        black: '#000000',
    },
    red: {
        '050': '#FFEFEC',
        '100': '#FFDFD8',
        '200': '#FFCCC1',
        '300': '#FFB9AA',
        '400': '#FF9682',
        '500': '#F97158',
        '600': '#F04C2E',
        '700': '#C0432C',
        '800': '#903829',
        '900': '#602B22',
        '950': '#301915',
    },
    green: {
        '050': '#E7F8E9',
        '100': '#CFF2D4',
        '200': '#A5EDBD',
        '300': '#8AE6A5',
        '400': '#7AD187',
        '500': '#56BD65',
        '600': '#34AA46',
        '700': '#2C883A',
        '800': '#24662E',
        '900': '#1B4421',
        '950': '#102213',
    },
    yellow: {
        '050': '#FFFAE0',
        '100': '#FFF4C1',
        '200': '#FFEE9E',
        '300': '#FFE779',
        '400': '#FFD347',
        '500': '#FEBF13',
        '600': '#D4A21A',
        '700': '#A9841E',
        '800': '#7F651F',
        '900': '#5F4B20',
        '950': '#2A2412',
    },
    blue: {
        '050': '#F0F7FF',
        '100': '#E0EEFF',
        '200': '#CDE2FF',
        '300': '#BAD6FF',
        '400': '#95BAFF',
        '500': '#6C9AFF',
        '600': '#427AFE',
        '700': '#3A66CB',
        '800': '#315198',
        '900': '#273B66',
        '950': '#172033',
    },
};
export const colors = {
    background: {
        backgroundPrimary: CORE_COLORS.neutrals.white,
        backgroundSecondary: CORE_COLORS.neutrals['050'],
        backgroundTertiary: CORE_COLORS.neutrals['100'],
        backgroundDisabled: CORE_COLORS.neutrals['200'],
        backgroundInverse: CORE_COLORS.neutrals['900'],
        backgroundFixed: CORE_COLORS.neutrals['900'],
        backgroundSuccess: CORE_COLORS.green['050'],
        backgroundError: CORE_COLORS.red['050'],
        backgroundWarning: CORE_COLORS.yellow['050'],
        backgroundInfo: CORE_COLORS.blue['050'],
    },
    content: {
        // onBackground is deprecated
        onBackground: CORE_COLORS.neutrals['950'],
        onBackgroundVariant: CORE_COLORS.neutrals['700'],
        onBackgroundDisabled: CORE_COLORS.neutrals['500'],
        onBackgroundInverse: CORE_COLORS.neutrals.white,
        onBackgroundSuccess: CORE_COLORS.green['600'],
        onBackgroundError: CORE_COLORS.red['600'],
        onBackgroundWarning: CORE_COLORS.yellow['600'],
        onSurface: CORE_COLORS.neutrals['950'],
        onSurfaceVariant: CORE_COLORS.neutrals['700'],
        onSurfaceDisabled: CORE_COLORS.neutrals['500'],
        onSurfaceError: CORE_COLORS.red['800'],
        onSurfaceWarning: CORE_COLORS.yellow['600'],
        onSurfaceSuccess: CORE_COLORS.green['600'],
        onSurfaceInfo: CORE_COLORS.blue['600'],
    },
    surface: {
        surfaceLow: CORE_COLORS.neutrals['100'],
        surfaceMid: CORE_COLORS.neutrals['050'],
        surfaceHigh: CORE_COLORS.neutrals.white,
        surfaceDisabled: CORE_COLORS.neutrals['200'],
        surfaceError: CORE_COLORS.red['050'],
        surfaceWarning: CORE_COLORS.yellow['100'],
        surfaceSuccess: CORE_COLORS.green['100'],
        surfaceInverse: CORE_COLORS.neutrals['900'],
        surfaceTrack: CORE_COLORS.neutrals['300'],
        surfaceScrim: `rgba(0, 0, 0, 0.5)`,
    },
    border: {
        border: CORE_COLORS.neutrals['100'],
        borderFocus: CORE_COLORS.neutrals['950'],
        borderDisabled: CORE_COLORS.neutrals['100'],
        borderVariant: CORE_COLORS.neutrals['200'],
        borderError: CORE_COLORS.red['600'],
        borderErrorFocus: CORE_COLORS.red['600'],
        borderWarning: CORE_COLORS.yellow['200'],
        borderWarningFocus: CORE_COLORS.yellow['500'],
    },
};
//# sourceMappingURL=colors.js.map